import { artImage } from './artAssets';

// Большие фоновые картинки игры и их версии (версия в адресе → при замене картинки браузеры берут новую).
// Фоны замка и полей заранее подгружаются после входа — открываются мгновенно, а не за 1–2 с.
export const CASTLE_BG_V = 'v7';
export const FIELDS_BG_V = 'v4';
export const LOGIN_BG_V = 'v1';
export const CASTLE_BG = `/art/castle/castle_mobile_portrait_v3.webp?${CASTLE_BG_V}`;
export const FIELDS_BG = `/art/castle/resource_mobile_portrait_v2.webp?${FIELDS_BG_V}`;

let warmed = false;
/** Скачать фоны замка и полей в кэш (в простое браузера, один раз за запуск). */
export function prefetchGameBackgrounds(castleBg = CASTLE_BG): void {
  if (warmed) return;
  warmed = true;
  // Через общий кэш картинок: замок и поля берут уже скачанный и распакованный фон
  const run = () => {
    for (const src of [castleBg, FIELDS_BG])
      void artImage(src)
        .decode?.()
        .catch(() => undefined);
  };
  const idle = (window as { requestIdleCallback?: (cb: () => void) => void }).requestIdleCallback;
  if (idle) idle(run);
  else setTimeout(run, 1500);
}
